import { runInAction } from "../../dependencies";
const mapIsSelectedHelper = (event, activeEventId) => {
    event.isSelected = event.id === activeEventId;
    return event;
};
export const mapIsSelected = (event, activeEventId) => runInAction(() => mapIsSelectedHelper(event, activeEventId));
//# sourceMappingURL=mapIsSelected.js.map